<template>
  <div class="sections">
    <section
      v-for="(content, index) in brand_content"
      :key="`home-section-${index}`"
      class="section"
    >
      <b-container>
        <info-banner
          v-if="content.type === INFO_BANNER_BLOCK"
          :direction="index % 2 === 0 ? 'right' : 'left'"
          v-bind="content.props || {}"
        />
        <point-list-01
          v-if="content.type === POINT_LIST_BLOCK"
          :direction="index % 2 === 0 ? 'right' : 'left'"
          v-bind="content.props || {}"
        />
        <value-proposition
          v-if="content.type === VALUE_PROPOSITION_BLOCK"
          :invert="index % 2 === 0"
          v-bind="content.props || {}"
        />
      </b-container>
    </section>
  </div>
</template>

<script>
import InfoBanner from "@/components/blocks/info-banner.vue"
import PointList01 from "@/components/library/blocks/point-list-01.vue"
import ValueProposition from "@/components/library/blocks/value-proposition.vue"
import {
  get_brand_content_builder,
  POINT_LIST_BLOCK,
  VALUE_PROPOSITION_BLOCK,
  INFO_BANNER_BLOCK,
} from "./script"

export default {
  name: "homepage-content",

  components: {
    "value-proposition": ValueProposition,
    "point-list-01": PointList01,
    "info-banner": InfoBanner,
  },

  props: {
    brand: {
      type: String,
      default: () => "",
    },
    authenticated: {
      type: Boolean, 
      default: () => false,
    }
  },

  data() {
    return {
      POINT_LIST_BLOCK,
      VALUE_PROPOSITION_BLOCK,
      INFO_BANNER_BLOCK,
    };
  },

  methods: {
    get_brand_content_builder,
  },

  computed: {
    brand_content() {
      const build_brand_content = this.get_brand_content_builder(this.brand, this.authenticated)
      const config = this.get_config()
      return build_brand_content(config)
    },
  },
}
</script>
